import React from 'react';
// Redux
import { useSelector, useDispatch } from 'react-redux';
// Components
import InternalContainer from '../../Components/InternalContainer';
import Pagination from '../../Components/Pagination';
import SummarySearch from '../../Components/SummarySearch';
import { LoadingSkeleton } from '../../Components/LoadingSkeleton';
import { SkeletonTypes } from '../../Components/LoadingSkeleton/types';
// Slice
import {
  setMultimedia,
  setIsMultimediaLoading,
  setPageMultimediaShowed,
  setPageMultimediaFetched,
} from '../../app/features/multimediaSlice';
// Services
import { getMultimedia } from '../../services/getMultimedia';
// Hooks
import { useScrollToTop } from '../../hooks/useScrollToTop';
// Styles
import './ResourcesPage.css';
import { FavoriteCategory } from '../FavoriteDetail/types';
import { useAuth } from '../../hooks/useAuth';
import MediaCard from '../../Components/MediaCard';
// Translate
import { useTranslation } from 'react-i18next';

const MediaResourcesPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isAuth } = useAuth();
  const { handleScrollToTop } = useScrollToTop();

  const {
    multimedia,
    is_multimedia_loading,
    total_multimedia,
    pageMultimediaShowed,
    pageMultimediaFetched,
  } = useSelector((state) => state.multimedia);

  const { queryFetched } = useSelector((state) => state.library);

  // Pagination
  const itemsPerPage = 8;
  const indexOfLastItem = pageMultimediaShowed * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = multimedia.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(total_multimedia / itemsPerPage);
  const totalCurrencyPages = Math.ceil(multimedia?.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    handleScrollToTop(0);
    if (newPage > pageMultimediaShowed) {
      dispatch(setPageMultimediaShowed(newPage));
      if (newPage > totalCurrencyPages - 1) {
        dispatch(setPageMultimediaFetched(pageMultimediaFetched + 1));
        getMultimedia(queryFetched, pageMultimediaFetched + 1)
          .then((response) => {
            dispatch(setMultimedia(response?.data?.data));
            dispatch(setIsMultimediaLoading(false));
          })
          .catch((error) => {
            console.error('Request error:', error);
          });
      }
    } else {
      if (pageMultimediaShowed > 1) {
        dispatch(setPageMultimediaShowed(newPage));
      }
    }
  };

  return (
    <>
      {is_multimedia_loading && (
        <main className='media-content'>
          <InternalContainer className='no-filters'>
            <section className='mediaResults'>
              {Array.from({ length: 12 }).map((_, i) => (
                <LoadingSkeleton
                  key={i}
                  type={SkeletonTypes.MEDIA_RESOURCE_CARD}
                />
              ))}
            </section>
          </InternalContainer>
        </main>
      )}

      {!is_multimedia_loading && multimedia?.length > 0 && (
        <main className='media-content'>
          <InternalContainer className='no-filters'>
            <SummarySearch total={total_multimedia} />

            <section>
              <div className='mediaResults'>
                {currentItems?.map((item, i) => (
                  <MediaCard
                    key={i}
                    image={item.thumbnail}
                    time={item.duration}
                    title={item.title}
                    description={item.description}
                    url={item.video_url}
                    language='EN'
                    type='new_tab'
                    favoriteCategory={FavoriteCategory.MEDIA}
                    showFavoriteButton={isAuth()}
                  />
                ))}
              </div>

              <Pagination
                pageShowed={pageMultimediaShowed}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            </section>
          </InternalContainer>
        </main>
      )}

      {!is_multimedia_loading &&
        total_multimedia === 0 &&
        queryFetched.length === 0 && (
          <main className='noDataContainerMultimedia'>
            <InternalContainer className='no-data'>
              <p>{t('Please enter a search term')}</p>
            </InternalContainer>
          </main>
        )}

      {!is_multimedia_loading &&
        multimedia?.length === 0 &&
        queryFetched.length > 0 && (
          <main className='noDataContainerMultimedia'>
            <InternalContainer className='no-data'>
              <p>{t('No data found')}</p>
            </InternalContainer>
          </main>
        )}
    </>
  );
};

export default MediaResourcesPage;
